import PropTypes from 'prop-types';
import React from 'react';
import PureComponent from 'ROOT/src/components/pure';

import ListViewTable2 from './listViewTable2';
import ListViewMenu from './ListViewMenu';
import ViewPanelMenu from 'ROOT/src/components/viewPanelMenu/viewPanelMenu';

import sAction from 'sAction';

class List extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.routeUrl();
    }

    routeUrl() {
        const queryString = window.location.hash.split('?')[1];
        // const module = window.location.hash.split('?')[0].split('/')[1];
        const module = sAction.parseURLHash(window.location.hash).module;

        if (!queryString) return;
        // parse query string to object of params
        const query = JSON.parse('{"' + queryString.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function(key, value) {
            return key === '' ? value : decodeURIComponent(value);
        });
        query.module = module;

        switch (query.action) {
            case 'download_file':
                this.actionDownloadFile(query);
                break;
            default:
                console.log('List url routing - no action');
                return;
        }
    }

    actionDownloadFile(query) {
        const searchData = {
            module: query?.module || 'aon_portal_documents',
            fields: ['id'],
            getFields: ['id', 'name', 'filename'],
            value: query.id,
            limit: 1,
        };

        sAction.quickSearch(searchData, (returnData) => {
            if (returnData.length > 0) {
                const splitFilename = returnData[0].filename.split('::');
                const data = {
                    id: splitFilename[0],
                    module: 'FieldFile',
                    name: splitFilename[1],
                    documentId: query.id,
                    moduleOrg: query.module,
                };
                sAction.downloadFile(data);
            } else {
                sAction.hidePopup();
                sAction.error(sAction.translate('LBL_LINKED_FILE_NOT_FOUND'));
            }
        });
    }

    render() {
        const data = this.props.data;
        const prefix = this.props.way;
        // const vName = sAction.app_strings.moduleList[data.modul];
        // const module = this.props.module;
        // const actionPanel = null;

        // pokud zmacknou esc, schovat pravy panel
        document.body.addEventListener('keyup', function(evt) {
            if (evt.code === 'Escape') {
                sAction.closeRightPanel();
            }
        });
        // obnova dat pri nechtenem / nahlem ukonceni
        sAction.setStorage('stopChanges', '0');
        const uId = sAction.dataGet('conf/user/id');
        const listModule = sAction.dataGet('view/modul');

        const changes = sAction.getStorage('changes-'+listModule+'-'+uId);
        // existuje zaznam k obnove, ktery neni priliz stary?
        if (changes &&
        (Object.keys(changes.changes.fields).length !== 0 ||
        (Object.keys(changes.changes.customData).length !== 0 && Object.keys(changes.changes.customData.customLines).length !== 0)
        ) && (changes.expiration - Date.now() > 0) && sAction.getStorage('stopChanges') !== 1) {
            // pokud ano, vyhodit pop-up
            sAction.popup('changesCheck', changes);
        }

        // end obnova

        return (
            <div
                className="pageContainer ListViewContainer"
                ref={this.table}
                onMouseMove={(e) => sAction.rowResizeMove(e)}
                onMouseUp={() => sAction.rowResizeStop()}
            >
                <div className="ListViewContainerBody">
                    <div className="listViewheaderBox">
                        <div className="listViewheaderBoxContainer">
                            <ListViewMenu data={data} prefix={prefix} />
                            {data.type != 'popup' && <ViewPanelMenu data={data} prefix={prefix} />}
                        </div>
                    </div>
                    <ListViewTable2 data={data} parent={this} prefix={prefix} />
                </div>
            </div>
        );
    }
}

List.propTypes = {
    data: PropTypes.shape({
        modul: PropTypes.any,
        type: PropTypes.string,
    }),
    module: PropTypes.any,
    way: PropTypes.any,
};
export default List;
